import { useEffect, useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { register } from '../../../Services/authService'
import toast from 'react-hot-toast'
import Loader from '../../Main/Loader'
import { me, updateProfile } from '../../../Services/DashboardServices'
import { useSelector } from 'react-redux'

const ProfileSetting = () => {
    const [name, setName] = useState("")
    const [email, setEmail] = useState("")
    const [contact, setContact] = useState("")
    const [isLoading, setIsLoading] = useState(false)
    const [loading, setLoading] = useState(false)


    const handleName = (e) => { setName(e.target.value) }
    const handleEmail = (e) => { setEmail(e.target.value) }
    const handleContact = (e) => { setContact(e.target.value) }
    const user = useSelector((state) => state.auth.data);


    const handleGetUser = async () => {
        setLoading(true)
        const response = await me(user?.id);
        if (response?.code === 200) {
            setName(response?.result?.user?.name)
            setEmail(response?.result?.user?.email)
            setContact(response?.result?.user?.contact)
        }
        else {
            setLoading(false)
        }
    }



    const handleSubmit = async (e) => {
        e.preventDefault();
        let body = {
            name,
            email,
            contact
        }
        setIsLoading(true)
        let response = await updateProfile(body)
        if (response.code === 200) {
            toast?.success(response?.message)

            setIsLoading(false)
            setName("")
            setEmail("")
            setContact("")
            handleGetUser();

        } else if (response.statusCode === 401) {
            toast?.error(response?.errors)
            setIsLoading(false)
        } else {
            // for (const [key, value] of Object.entries(response?.errors)) {
            //     toast?.error(value)
            // }
            setIsLoading(false)
        }
        setIsLoading(false)
    }

    useEffect(() => { handleGetUser(); }, [])


    return (
        <>
            <div className="">
                <div className="row justify-content-center">
                    <div className="col-lg-12">
                        <div className="card border-0 shadow p-3 mt-3">

                            <h3 className='fw-bold'>Update Profile</h3>

                            <Form onSubmit={handleSubmit}>

                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label>Email address</Form.Label>
                                    <Form.Control onChange={handleEmail} value={email} readOnly type="email" placeholder="Enter email" />
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="">
                                    <Form.Label>Full Name</Form.Label>
                                    <Form.Control onChange={handleName} value={name} type="text" placeholder="Enter full name" />
                                </Form.Group>

                                <Form.Group className="mb-3 phone-number" controlId="">
                                    <Form.Label>Phone Number</Form.Label>
                                    <Form.Control onChange={handleContact} value={contact} type="number" placeholder="Enter phone number" />
                                </Form.Group>


                                <Button variant="primary" className='w-100' type="submit">
                                    {
                                        isLoading ? <Loader /> : "Update"
                                    }
                                </Button>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ProfileSetting